import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AccordionModule } from '@openng/optimus-ui/accordion';
import { Badge } from '@openng/optimus-ui/badge';
import { ButtonComponent } from '../../../../components/kit/button/button.component';
import { RecentlyVisitedStore } from './recently-visited.store';

@Component({
    selector: 'app-recently-visited',
    templateUrl: './recently-visited.component.html',
    styleUrls: ['./recently-visited.component.scss'],
    imports: [
        AccordionModule,
        ButtonComponent,
        Badge,
    ],
    providers: [
        RecentlyVisitedStore,
    ],
})
export class RecentlyVisitedComponent {

    protected readonly router = inject(Router);
    protected readonly store = inject(RecentlyVisitedStore);

    public async navigate(url: string): Promise<void> {
        if (url) {
            await this.router.navigateByUrl(url, { state: { fromHistory: true } });
        }
    }
}
